export const BUSINESS_FORM_DATA = 'BUSINESS_FORM_DATA'
export const BUSINESS_FEE_DATA = 'BUSINESS_FEE_DATA'